<template>
  <div id="pay">
    <mt-popup v-model="show" :closeOnClickModal="0" position="bottom" class="pay-popup">
      <div class="header" @click="cancelClick">
        <div class="close"></div>
        <div class="tip">{{title}}</div>
      </div>
      <div class="pay-money pay-money2">
        <div class="money">￥{{Number(buy).toFixed(2)}}</div>
      </div>
      <div class="pay-type">
        <div
          class="pay-box"
          v-for="(value, index) in items"
          :key="index"
          @click="selPayTypeClick(index+1)"
        >
          <img class="icon" :src="value.image" />
          <div>{{value.title}}</div>
          <img class="select" :id="forId(index)" src="../assets/radio_n.png" />
        </div>
      </div>

      <div class="bottom">
        <div class="apply" @click="surePayClick" :style="{backgroundColor:activeStyle}">确认支付</div>
      </div>
    </mt-popup>
    <div v-html="htmlForm"></div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
// import pingpp from 'pingpp-js'
export default {
  props: { // 0 中消通支付 1 安全管家支付 2 风险评测支付  4 购买产品订单
    show: 0, // 展示
    type: 0,
    buy: {
      type: String,
      default: '0'
    },
    order: {
      type: String
    },
    buyid: {
      type: String
    }
  },
  data () {
    return {
      title: '',
      money: '',
      items: [
        { id: '1', title: '支付宝支付', image: require('../assets/icon_pay_alipay.png') },
        { id: '2', title: '微信支付', image: require('../assets/icon_pay_wx.png') },
        { id: '3', title: '银行汇款', image: require('../assets/icon_pay_bank.png') }
      ],
      msgImg_n: require('../assets/radio_n.png'),
      msgImg_s: require('../assets/radio_s.png'),
      activeStyle: '#FECDCD',
      isProtocol: 0,
      payMoneyData: [], // 风险评测 金额类型
      payMoneyIndex: -1, // 风险评测 支付金额 类型
      payIndex: 0, // 支付 类型
      payType: '',
      payInfo: {},
      timerState: '',
      orderid: '', // 获取订单号
      htmlForm: ''
    }
  },
  methods: {
    forId (index) {
      return 'selectImg' + index
    },
    cancelClick () {
      if (this.orderid) {
        this.$Message.success('你有未支付的订单')
      }
      // 取消 支付
      this.$emit('payValue', 0)
    },
    selPayTypeClick (index) { // 判断支付类型 支付宝 微信 银行卡
      this.payIndex = index
      switch (this.payIndex) {
        case 1:
          this.payType = 'alipay_wap'
          break
        case 2:
          this.payType = 'wx_wap'
          break
        case 3:
          this.payType = 'remittance'
          break
      }

      var length = document.querySelectorAll('.pay-box').length
      for (let i = 0; i < length; i++) {
        if (index - 1 === i) {
          document.getElementById('selectImg' + i).src = this.msgImg_s
        } else {
          document.getElementById('selectImg' + i).src = this.msgImg_n
        }
      }

      // 生成本未支付的订单
      if (!this.orderid) {
        this.utils.POSTHeader(this.companyUrl + '/zxOrder/newMallOrder', {
          'Content-Type': 'application/json',
          'Cache-control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 0,
          'zxzxkey': ''
        }, JSON.parse(this.order), (response) => {
          if (response.success === true) {
            this.orderid = response.data.id
            sessionStorage.setItem('orderid', true)
            this.$Message.success('已生成待支付订单')
          }
        })
      }
    },

    checkPayParam: function () {
      if (this.payIndex <= 0) {
        Toast('请选择支付方式！')
        return false
      }

      return true
    },
    surePayClick () {
      var _this = this
      if (this.checkPayParam() === false) {
        return
      }
      if (this.payIndex === 3) { // 线下 审核汇款
        console.log('===================线下汇款')
        this.$router.push({ path: 'pay-bank', query: { orderID: this.orderid, type: this.type } })
      } else { // 支付宝 微信支付  下单 支付
        this.utils.POST(this.companyUrl + '/newPay/' + this.payType + '/' + this.orderid, null, (responseObj) => {
          let payUrl = responseObj.data.payUrl
          if (payUrl.indexOf('http') === 0) { // 微信
            console.log('微信支付==============================')
            window.location.href = payUrl
          } else { // 支付宝
            _this.htmlForm = payUrl
            console.log('微信支付==============================')
            setTimeout(function () {
              document.forms[0].submit()
            }, 500)
          }
          // pingpp.createPayment(responseObj.data, (result, err) => {
          //   if (result === 'success') {
          //     this.$emit('payValue', 1)
          //     sessionStorage.removeItem('orderid')
          //     // 只有微信公众账号 (wx_pub)、微信小程序 (wx_lite)、QQ 公众号 (qpay_pub)、支付宝口碑 (alipay_qr)
          //     // 支付成功的结果会在这里返回，其他的支付结果都会跳转到 extra 中对应的 URL。
          //   } else if (result === 'fail') {
          //     // data 不正确或者微信公众账号/微信小程序/QQ 公众号/支付宝口碑支付失败时会在此处返回
          //   } else if (result === 'cancel') {
          //     // 微信公众账号、微信小程序、QQ 公众号、支付宝口碑支付取消支付
          //   }
          // })
          // 查询支付状态
          this.payState()
        })
      }
    },
    payState () {
      // 查询支付状态

      this.utils.POST(this.companyUrl + '/pay/status/' + this.orderid, null, (response) => {
        if (response.data.pay_state === '未付款') {
          this.timerState = setTimeout(function () {
            this.payState()
          }, 5000)
        } else {
          clearTimeout(this.timerState)
          Toast('支付成功了！')
          this.$emit('payValue', 1)
        }
      })
    }

  },
  watch: {
    $router () {
    },
    isActive: function (val) {
      if (val === true) {
        this.activeStyle = '#C41335'
      } else {
        this.activeStyle = '#FECDCD'
      }
    }
  },
  computed: { // 计算
    isActive: function () {
      if (this.type === '4') {
        if (this.payIndex > 0) {
          return true
        }
      }
      return false
    }

  },
  mounted () {
    // 微信 分享
    console.log('支付界面类型000000======---------' + this.type)
    switch (this.type) {
      case '4':
        this.title = '购买产品订单'
        break
    }
  }
}
</script>

<style scoped>
#pay {
  width: 100%;
}
.pay-popup {
  width: 100%;
  /*height: 400px;*/
}
.header {
  position: relative;
  width: 100%;
  height: 45px;
  line-height: 45px;
  color: #000000;
  font-size: 17px;
  /*background-color: #C41335;*/
  border-bottom: solid #eeeeee 1px;
  box-sizing: border-box;
}
.header .close {
  position: absolute;
  top: 15px;
  left: 15px;
  width: 15px;
  height: 15px;
  padding: 5px;
  background-image: url('../assets/icon-pay-close.png');
  background-size: cover;
  background-position: center center;
}
.header .tip {
  position: absolute;
  left: 0px;
  right: 0px;
  text-align: center;
}
.pay-money {
  position: relative;
  /*background-color: yellow;*/
}
.pay-money1 .money,
.pay-money2 .money {
  position: relative;
  height: 60px;
  padding-top: 30px;
  line-height: 30px;
  font-size: 25px;
  font-weight: bold;
  color: #c41335;
  text-align: center;
}
.pay-money1 .money .tip,
.pay-money2 .money .tip {
  font-weight: normal;
  font-size: 15px;
  color: #000000;
  margin-left: 5px;
}
.pay-money .omoney {
  position: relative;
  height: 30px;
  line-height: 30px;
  font-size: 15px;
  color: #bebebe;
  text-align: center;
  text-decoration: line-through;
}
.pay-money3 {
  width: 100%;
  overflow-x: scroll;
}
.pay-money3 .content {
  position: relative;
  margin-top: 20px;
  margin-bottom: 10px;
  height: 90px;
  width: 560px;
}
.pay-money3 .content .money-box {
  position: relative;
  float: left;
  width: 170px;
  height: 88px;
  margin-left: 15px;
  /*border: solid #cccccc 1px;*/
  /*box-sizing: border-box;*/
  /*background-color: #F9F9F9;*/
}
.defaultMoney {
  border: solid #cccccc 1px;
  box-sizing: border-box;
  background-color: #f9f9f9;
}
.selectMoney {
  border: solid #c41335 1px;
  box-sizing: border-box;
  background-color: #ffecec;
}
.pay-money3 .content .recommend {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 40px;
  height: 22px;
  line-height: 22px;
  background-color: #c41335;
  color: #ffffff;
  font-size: 13px;
  text-align: center;
}
.pay-money3 .content .center {
  position: absolute;
  top: 25px;
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
}
.pay-money3 .content .center .tip1 {
  color: #c41335;
  font-size: 13px;
  font-weight: normal;
}
.pay-money3 .content .center .money {
  color: #c41335;
  font-size: 18px;
  font-weight: bold;
}
.pay-money3 .content .center .tip2 {
  color: #333333;
  font-size: 13px;
  font-weight: normal;
}
.pay-money3 .content .bottom {
  position: absolute;
  left: 35px;
  top: 50px;
  width: 100px;
  height: 22px;
  line-height: 22px;
  background-color: #c41335;
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  border-radius: 11px;
}
.pay-money3 .content .bottom span {
  color: #ffff00;
  font-size: 13px;
  font-weight: normal;
  font-weight: bold;
}
.pay-money3 .content .image {
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 16px;
  height: 16px;
  background-image: url(../assets/icon-sel.jpg);
  background-size: cover;
  background-position: center center;
}
.pay-type {
  position: relative;
  width: 100%;
  /*top: 30px;*/
  padding-top: 10px;
}
.pay-box {
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 60px;
  /*background-color: #4BAE4F;*/
}
.pay-box .icon {
  position: absolute;
  top: 20px;
  left: 15px;
  width: 20px;
  height: 20px;
}
.pay-box div {
  position: absolute;
  top: 0px;
  left: 50px;
  width: calc(100% - 60px);
  height: 60px;
  line-height: 60px;
  border-bottom: solid #eeeeee 1px;
  box-sizing: border-box;
}
.pay-box .select {
  position: absolute;
  top: 20px;
  right: 15px;
  width: 20px;
  height: 20px;
}
.protocol {
  position: relative;
  width: 100%;
  height: 65px;
  line-height: 65px;
  /*background-color: yellow;*/
}
.protocol img {
  position: absolute;
  left: 25px;
  width: 22px;
  height: 22px;
  top: 21px;
  object-fit: cover;
}
.protocol .tip {
  position: absolute;
  top: 10px;
  left: 60px;
  width: 250px;
  height: 45px;
  line-height: 45px;
  color: #333333;
  font-size: 14px;
}
.protocol .tip div {
  position: absolute;
  top: 0px;
  left: 95px;
  width: 150px;
  height: 45px;
  line-height: 45px;
  color: #c41335;
  font-size: 14px;
}
.bottom {
  position: relative;
  width: 100%;
  bottom: 0px;
  height: 65px;
  line-height: 65px;
  background-color: #ffffff;
  /*border-top: solid #EEEEEE 1px;*/
  /*box-sizing: border-box;*/
}
.bottom .apply {
  position: absolute;
  top: 10px;
  left: 15px;
  height: 45px;
  line-height: 45px;
  width: calc(100% - 30px);
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  background-color: #c41335;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/buy.vue